<style scoped>
.mymodal {
  position: fixed;
  z-index: 3;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0,0,0);
  background-color: rgba(0,0,0,0.4);
}
.mymodal-center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.mymodal-content{
  position:fixed;
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  border-radius: 5px;
  width: 300px;
  overflow-y: auto;
}
.mymodal-body {
  display: flex;
  align-items: center;
  justify-content: center;
}
.mymodal-footer {
  padding-top: 5px;
  display: flex;
  justify-content: flex-end;
}
#contact{
  font-family: 微軟正黑體;
}
.text-blue{
  color: 	#003377;
}
@media (max-width:316px) {
  .email{margin-left: -13px;}
}
.addr_img{
  transition: transform 0.5s;
  -moz-transition: transform 0.5s;	/* Firefox 4 */
  -webkit-transition: transform 0.5s;	/* Safari 和 Chrome */
  -o-transition: transform 0.5s;
}

@media(max-width:992px){
  .addr_img{
    transform:scale(1.3,1.3);
  }
}
@media(max-width:768px){
  .addr_img{
    transform:scale(1.65,1.65);
  }
}
@media(max-width:576px){
  .addr_img{
    transform:scale(2,2);
  }
}
.error{
    color:red;
}
</style>

<template>
    <div>
        <div class="mymodal" v-if="sending.status">
            <div class="mymodal-center">
                <div class="mymodal-content">
                    <div class="mymodal-body">
                        <div v-if="sending.loading">發送訊息中請稍後...</div>
                        <div v-if="(sending.loading === false) ? true:false">{{sending.request}}</div>
                    </div>
                    <div class="mymodal-footer">
                        <button v-if="(sending.loading === false) ? true:false" class="btn btn-primary" v-on:click="sending.status = false">OK</button>
                    </div>
                </div>
            </div>
        </div>
        <div style="overflow:hidden;">
            <a href="https://www.google.com.tw/maps/place/%E5%86%A0%E5%85%A8%E8%B3%87%E8%A8%8A%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/@24.1188475,120.6583358,17z/data=!3m1!4b1!4m5!3m4!1s0x34693c56b2134981:0x22bf810ea7bb8557!8m2!3d24.1188475!4d120.6605245?hl=zh-TW&authuser=0">
                <img src="../assets/images/kcsys-address.png?20181011" class="img-fluid addr_img" width="100%">
            </a>
        </div>
        <div class="container-fluid">
            <div class="row justify-content-around" id="contact">
                <div class="col-lg-5  my-5">
                    <div class="container">
                        <h4 class="text-blue"><b>聯絡我們</b></h4>
                        <hr>
                        <form id="myform" v-on:submit.prevent="submit">
                            <div class="form-group">
                                <label>姓名<b class="text-danger">*</b></label>
                                <input type="text" class="form-control" v-model="name"  placeholder="請輸入姓名" required>
                            </div>
                            <div class="form-group ">
                                <label>Email<b class="text-danger">*</b></label>
                                <input type="email" class="form-control" v-model="email" placeholder="請輸入Email" required>
                            </div>
                            <div class="form-group">
                                <label>電話<b class="text-danger">*</b></label>
                                <input id="inputphone" type="text" class="form-control" v-model="phone" placeholder="請輸入電話 0x-xxxxxxxxx" required>
                            </div>
                            <div class="form-group">
                                <label for="exampleFormControlTextarea1">留言</label>
                                <textarea v-model="content" class="form-control" id="exampleFormControlTextarea1" rows="3" required></textarea>
                            </div>
                            <div class="form-group">
                                <img id="captcha_img" :src="captcha_src" alt="" style="padding-bottom: 10px;" v-on:click="getCaptcha">
                                <input type="text" class="form-control" v-model="captcha" placeholder="請輸入驗證碼" required>
                            </div>

                            <button type="submit" class="btn btn-primary" id="send">送出</button>
                        </form>

                    </div>
                </div>
                <div class="col-lg-5 my-5">
                    <div class="container">
                        <h4 class="text-blue"><b>聯絡資訊</b></h4>
                        <hr>
                        <div class="row justify-content-center align-items-center my-4">
                            <div class="col-2 ">
                                <img src="../assets/images/headlogo.jpg" alt="" width="100%" style="min-width:30.06px;min-height:28.91px;">
                            </div>
                            <div class="col-8 offset-2">
                                <h5>冠全資訊有限公司</h5>
                            </div>
                        </div>
                        <div class="row justify-content-start my-4">
                            <div class="col-1">
                                <i class="fas fa-map-marker-alt text-dark" style="font-size:25px;"></i>
                            </div>
                            <div class="col-3 mb-2 text-dark" style="min-width:70.3px;">
                                <h5><b>地址</b></h5>
                            </div>
                            <div class="col-sm-7">
                                <h5>台中市南區工學北路116號</h5>
                            </div>
                        </div>
                        <div class="row justify-content-start my-4">
                            <div class="col-1">
                                <i class="fas fa-phone text-dark" style="font-size:25px;"></i>
                            </div>
                            <div class="col-3 mb-2 text-dark" style="min-width:70.3px;">
                                <h5><b>電話</b></h5>
                            </div>
                            <div class="col-sm-7">
                                <h5>04-2265 6615</h5>
                            </div>
                        </div>
                        <div class="row justify-content-start my-4">
                            <div class="col-1">
                                <i class="fas fa-envelope text-dark" style="font-size:25px;"></i>
                            </div>
                            <div class="col-3 mb-2 text-dark" style="min-width:70.3px;">
                                <h5><b>信箱</b></h5>
                            </div>
                            <div class="col-sm-7 email" style="min-width:249.6px">
                                <h5>kc.service@kcsys.com.tw</h5>
                            </div>
                        </div>
                        <div class="row justify-content-start my-4">
                            <div class="col-1">
                                <i class="fas fa-fax text-dark" style="font-size:25px;"></i>
                            </div>
                            <div class="col-3 mb-2 text-dark" style="min-width:70.3px;">
                                <h5><b>傳真</b></h5>
                            </div>
                            <div class="col-sm-7">
                                <h5>04-2265 5427</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            captcha_src:'',
            captcha_key:null,
            name:'',
            email:'',
            phone:'',
            content:'',
            captcha:'',
            sending: {
                status: false,
                loading: true,
                request: null
            }
        }
    },
    mounted(){
        this.getCaptcha();
    },
    methods:{
        getCaptcha:function() {
            const self =this;
            this.$http.get(`https://www.kcsys.com.tw/kcsys/public/captcha/api`)
            .then((response) => {
                self.captcha_src =  response.data.img;
                self.captcha_key = response.data.key;
            })
        },
        submit:function() {
            this.sending.status = true;
            this.sending.loading = true;
            this.sending.request = null;

            const self = this;
            let axios = this.$http;
            let params = new URLSearchParams();

            let data = {
                name: self.name,
                email: self.email,
                phone: self.phone,
                content: self.content,
                captcha: self.captcha,
                key: self.captcha_key
            }
            axios({
                method: 'post',
                url: 'https://www.kcsys.com.tw/kcsys/public/api/v1/messages',
                data: data
            })
            .then(function (response) {
                self.sending.loading = false;
                self.sending.request = response.data.request;
            })
            .catch(function (error) {
                self.sending.loading = false;
                self.sending.request = '發送失敗';
                console.log(error);
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/contact.vue